/**
 * What a platform points system's or salary model's read-only view says about its test scope (#583, customer trials
 * CT89).
 *
 * The API withholds a platform version's `previewScope` from anybody but an administrator, so an operator's builder
 * opens on the default test scope rather than the administrator's. The notice says so, rather than letting the
 * default read as the platform's own choice.
 */
export const PLATFORM_TEST_SCOPE_NOT_SHOWN = 'The platform’s test scope is not shown.';

/**
 * The sentence for a platform entry whose version came back without a test scope, and null otherwise: an
 * administrator is answered the scope, and a room's own version with none stored has had nothing withheld.
 */
export function platformTestScopeNotice(
  entry: { isPlatform: boolean },
  version: { previewScope: unknown },
): string | null {
  return entry.isPlatform && version.previewScope == null ? PLATFORM_TEST_SCOPE_NOT_SHOWN : null;
}
